// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39uAG","name":"styles_name__335og","phone":"styles_phone__1HcQy"};